module.exports = __webpack_public_path__ + "img/wfb.4a097c3b.png";